export default __webpack_public_path__ + "static/0312-f6b62607dce2848d6c0dd34207bc6323.png";